ModelLoader = undefined
queueRequire -> ModelLoader = require 'db/model-loader'
_ = require 'underscore'
l = require 'lib/localize'
Auth = require 'db/auth'
getExperiment = require 'lib/experiments/simple-test'
{ ErrorViews } = require 'common/data/error-views'

module.exports =
  routes: [['*splat', 'displayErrorPage']]

  displayErrorPage: (opts) ->
    ModelLoader.await('headerData')
    .then =>
      if Auth.me() && Auth.isLoggedIn() && !Auth.confirmed() &&
          getExperiment('confirmDuringSignup').get('enabled')
        return @navigate '/confirm-email', { trigger: true }

    data = _.extend { errorType: ErrorViews.NOT_FOUND }, opts,
      url: location.pathname + location.search
      isLoggedIn: Auth.isLoggedIn()

    # TODO: To route to Gamma, uncomment this line… ⤵
    # @navigate '/error', { trigger: true, state: data }

    # …and delete this one ⤵
    @errorView { title: l('error'), data }


// WEBPACK FOOTER //
// ./app/scripts/controller/catchall-route.coffee